import * as actionTypes from "../constants/actionTypes";
import * as config from "../constants/config";
import * as handlers from "../constants/handlers";
import * as methods from "../constants/methods";
import * as getActions from "./getActions";

export const matchingTabInit = (tabId, product = null) => ({
    type: actionTypes.MATCHING_TAB_INIT,
    payload: {
        tabId: tabId,
        product: product
    }
});

export const matchingTabInitSearch = (tabId) => ({
    type: actionTypes.MATCHING_TAB_INIT_SEARCH,
    payload: {
        tabId: tabId
    }
});

export const matchingTabFromPallete = (color, product) => ({
    type: actionTypes.MATCHING_TAB_FROM_PALETTE,
    payload: {
        colorId: color.id,
        fandeckId: color.fandeckId,
        local: false,
        product: product
    }
});

export const matchingTabFromColorSearch = (color, fandeck, product) => ({
    type: actionTypes.MATCHING_TAB_FROM_COLOR_SEARCH,
    payload: {
        colorId: color.id,
        fandeckId: fandeck.id,
        local: color.local,
        product: product
    }
});

export const getSpectralDataForCif = (tabId, colorId, fandeckId, callback) => ({
    type: actionTypes.SERVER_REQUEST,
    payload: {
        type: methods.METHOD_GET_COLOR_IN_FANDECK_DATA,
        params: {
            colorId: colorId,
            fandeckId: fandeckId,
            isLocal: false
        }
    },
    method: handlers.MATCHING_TAB_GET_DETAIL,
    tabId: tabId,
    next: callback
});

export const matchingTabFromStats = (tabId, measurementResult) => ({
    type: actionTypes.MATCHING_TAB_FROM_STATS,
    payload: {
        tabId: tabId,
        measurementResult: measurementResult
    }
});

export const matchingInitEngine = (newTabId = 0) => {
    return {
        type: actionTypes.MATCHING_INIT_ENGINE,
        payload: {
            tabId: newTabId
        }
    };
};

export const matchingInit = (tabId = 0) => ({
    type: actionTypes.SERVER_REQUEST,
    payload: {
        type: methods.METHOD_MATCHING_INIT
    },
    method: handlers.MATCHING_INIT,
    tabId: tabId
});

export const matchingAvailable = (tabId = 0) => ({
    type: actionTypes.SERVER_REQUEST,
    payload: {
        type: methods.METHOD_MATCHING_CAN_BE_USED
    },
    method: handlers.MATCHING_CAN_BE_USED,
    tabId: tabId
});

export const getMatchingProducts = (tabId = 0) => ({
    type: actionTypes.SERVER_REQUEST,
    payload: {
        type: methods.METHOD_GET_PRODUCTS_AVAILABLE_FOR_MATCHING
    },
    method: handlers.MATCHING_GET_PRODUCTS_AVAILABLE_FOR_MATCHING,
    tabId: tabId
});

export const getMatchingColorfiles = (tabId, productId) => ({
    type: actionTypes.SERVER_REQUEST,
    payload: {
        type: methods.METHOD_GET_COLOR_FILES_FOR_PRODUCT,
        params: {
            productId: productId
        }
    },
    method: handlers.MATCHING_GET_COLOR_FILES_FOR_PRODUCT,
    tabId: tabId
});

export const getColorfileDetail = (tabId, productId, colorfileId) => ({
    type: actionTypes.SERVER_REQUEST,
    payload: {
        type: methods.METHOD_GET_COLOR_FILE_DETAIL,
        params: {
            productId: productId,
            colorFileId: colorfileId
        }
    },
    method: handlers.MATCHING_GET_COLORIFILE_DETAIL,
    tabId: tabId
});

export const getMatchingPackages = (tabId, productId, baseIds) => ({
    type: actionTypes.SERVER_REQUEST,
    payload: {
        type: methods.METHOD_GET_PACKAGES_BY_BASES,
        params: {
            productId: productId,
            baseIds: baseIds
        }
    },
    method: handlers.MATCHING_GET_PACKAGES,
    tabId: tabId
});

export const selectProduct = (tabId, product) => ({
    type: actionTypes.MATCHING_TAB_SELECT_PRODUCT,
    payload: {
        tabId: tabId,
        product: product
    }
});

export const selectColorfile = (tabId, colorfile) => ({
    type: actionTypes.MATCHING_TAB_SELECT_COLORFILE,
    payload: {
        tabId: tabId,
        colorfile: colorfile
    }
});

export const selectCorrectionColorfile = (tabId, colorfile) => ({
    type: actionTypes.MATCHING_TAB_SELECT_CORRECTION_COLORFILE,
    payload: {
        tabId: tabId,
        colorfile: colorfile
    }
});

export const selectBase = (tabId, base) => ({
    type: actionTypes.MATCHING_TAB_SELECT_BASE,
    payload: {
        tabId: tabId,
        base: base
    }
});

export const removeBase = (tabId, base) => ({
    type: actionTypes.MATCHING_TAB_REMOVE_BASE,
    payload: {
        tabId: tabId,
        base: base
    }
});

export const selectPackage = (tabId, selectedPackage) => ({
    type: actionTypes.MATCHING_TAB_SELECT_PACKAGE,
    payload: {
        tabId: tabId,
        selectedPackage: selectedPackage
    }
});

export const setInclude = (tabId, colorants) => ({
    type: actionTypes.MATCHING_TAB_SET_COLORANT,
    payload: {
        tabId: tabId,
        colorants: colorants
    }
});

export const selectTemplate = (tabId, template) => ({
    type: actionTypes.MATCHING_TAB_SELECT_TEMPLATE,
    payload: {
        tabId: tabId,
        template: template
    }
});

export const startMatching = (
    tabId,
    targetSpectralCurve,
    productId,
    colorFileId,
    baseInProductIds,
    packageId,
    templateId,
    includedColorantsIds,
    excludedColorantsIds,
    rowCount
) => ({
    type: actionTypes.SERVER_REQUEST,
    payload: {
        type: methods.METHOD_GET_COLOR_MATCH_DATA,
        params: {
            targetSpectralCurve: targetSpectralCurve,
            productId: productId,
            colorFileId: colorFileId,
            baseInProductIds: baseInProductIds,
            packageId: packageId,
            templateId: templateId,
            includedColorantsIds: includedColorantsIds,
            excludedColorantsIds: excludedColorantsIds,
            rowCount: rowCount
        }
    },
    method: handlers.MATCHING_GET_RESULT,
    tabId: tabId
});

export const startCorrection = (
    tabId,
    targetSpectralCurve,
    trialSpectralCurve,
    trialFormula,
    productId,
    colorFileId,
    baseInProductId,
    baseInProductPackageId
) => ({
    type: actionTypes.SERVER_REQUEST,
    payload: {
        type: methods.METHOD_GET_FORMULA_CORRECTION_DATA,
        params: {
            targetSpectralCurve: targetSpectralCurve,
            trialSpectralCurve: trialSpectralCurve,
            trialFormula: trialFormula,
            productId: productId,
            colorFileId: colorFileId,
            baseInProductId: baseInProductId,
            baseInProductPackageId: baseInProductPackageId
        }
    },
    method: handlers.CORRECTION_GET_RESULT,
    tabId: tabId
});

export const startReformulate = (
    tabId,
    targetSpectralCurve,
    trialSpectralCurve,
    trialFormula,
    productId,
    colorFileId,
    baseInProductId,
    baseInProductPackageId
) => ({
    type: actionTypes.SERVER_REQUEST,
    payload: {
        type: methods.METHOD_GET_FORMULA_REFORMULATION_DATA,
        params: {
            targetSpectralCurve: targetSpectralCurve,
            trialSpectralCurve: trialSpectralCurve,
            trialFormula: trialFormula,
            productId: productId,
            colorFileId: colorFileId,
            baseInProductId: baseInProductId,
            baseInProductPackageId: baseInProductPackageId
        }
    },
    method: handlers.REFORMULATION_GET_RESULT,
    tabId: tabId
});

export const selectMatchingResult = (tabId, matchingResult) => ({
    type: actionTypes.MATCHING_TAB_SELECT_MATCHING_RESULT,
    payload: {
        tabId: tabId,
        matchingResult: matchingResult
    }
});

export const saveMatchingFormulaAsCustom = (tabId) => ({
    type: actionTypes.SAVE_MATCHING_FORMULA_AS_CUSTOM,
    payload: {
        tabId: tabId
    }
});

export const saveHistoryFormulaAsCustom = (tabId, statistics) => ({
    type: actionTypes.SAVE_HISTORY_FORMULA_AS_CUSTOM,
    payload: {
        tabId: tabId,
        statistics: statistics
    }
});

export const selectFandeck = (tabId, fandeck) => ({
    type: actionTypes.MATCHING_TAB_SELECT_FANDECK,
    payload: {
        tabId: tabId,
        fandeck: fandeck
    }
});

export const resetFandeck = (tabId) => ({
    type: actionTypes.MATCHING_TAB_SELECT_FANDECK,
    payload: {
        tabId: tabId,
        fandeck: null
    }
});

export const getFandeckList = (tabId, colorId, fandeckName, fts) =>
    getActions.getFandecksByParams(
        tabId,
        null,
        colorId,
        null,
        fandeckName,
        false,
        fts,
        false,
        false,
        handlers.MATCHING_TAB_GET_FANDECK_LIST,
        config.MAX_FANDECK_LIMIT,
        0,
        true
    );

export const selectColor = (tabId, color) => ({
    type: actionTypes.MATCHING_TAB_SELECT_COLOR,
    payload: {
        tabId: tabId,
        color: color
    }
});

export const resetColor = (tabId) => ({
    type: actionTypes.MATCHING_TAB_SELECT_COLOR,
    payload: {
        tabId: tabId,
        color: null
    }
});

export const getColorList = (tabId, fandeckId, colorName, fts) =>
    getActions.getColorsByParams(
        tabId,
        null,
        fandeckId,
        null,
        colorName,
        null,
        false,
        fts,
        false,
        false,
        handlers.MATCHING_TAB_GET_COLOR_LIST,
        config.MAX_FORMULA_LIMIT,
        0,
        null,
        true,
        true
    );

export const initQualityControl = (tabId) => ({
    type: actionTypes.QUALITY_CONTROL_INIT,
    payload: {
        tabId: tabId
    }
});

export const selectCustomFandeck = (tabId, fandeck) => ({
    type: actionTypes.MATCHING_SELECT_CUSTOM_FANDECK,
    payload: {
        tabId: tabId,
        fandeck: fandeck
    }
});

export const changeColorName = (tabId, name) => ({
    type: actionTypes.MATCHING_TAB_CHANGE_COLOR_NAME,
    payload: {
        tabId: tabId,
        name: name
    }
});

export const setDraftFormulaScene = (tabId, colorRgb) => ({
    type: actionTypes.MATCHING_TAB_SET_DRAFT_FORMULA_SCENE,
    payload: {
        tabId: tabId,
        color: colorRgb
    }
});

export const setCorrectionScene = (tabId, measurementResult, targetMeasurementResult, targetFormula) => ({
    type: actionTypes.MATCHING_TAB_SET_CORRECTION_SCENE,
    payload: {
        tabId: tabId,
        measurementResult: measurementResult,
        targetMeasurementResult: targetMeasurementResult,
        targetFormula: targetFormula
    }
});
